/**
 * Apple OAuth 配置
 * 使用 Apple Sign In JS SDK
 * 文档：https://developer.apple.com/documentation/sign_in_with_apple/sign_in_with_apple_js
 */

// Apple Client ID（从 Apple Developer Console 获取）
export const APPLE_CLIENT_ID = import.meta.env.VITE_APPLE_CLIENT_ID || ''

// Apple 重定向 URI（需要在 Apple Developer Console 配置）
export const APPLE_REDIRECT_URI = `${import.meta.env.VITE_API_BASE_URL}/auth/v1/apple_auth_callback`

// Apple OAuth 配置
export const APPLE_CONFIG = {
  // Client ID (Service ID)
  clientId: APPLE_CLIENT_ID,

  // 重定向 URI
  redirectURI: APPLE_REDIRECT_URI,

  // 请求的权限范围
  scope: 'name email',

  // 响应类型（使用 code 进行服务端验证）
  responseType: 'code id_token',

  // 响应模式（使用 form_post 或 query）
  // 注意：当请求 name 或 email scope 时，必须使用 form_post
  responseMode: 'form_post',

  // 使用弹窗模式
  usePopup: true, // 使用 JS SDK 的弹窗模式
}

/**
 * Apple Developer Console 配置说明：
 *
 * 1. 创建 Services ID（用作 Client ID）
 *
 * 2. 配置 Sign in with Apple
 *    - 启用 Sign in with Apple
 *    - 配置 Web 认证
 *    - 添加域名和返回 URL
 *      - 域名：yourdomain.com
 *      - 返回 URL：https://yourdomain.com/oauth/callback
 *
 * 3. 创建私钥（用于服务端验证 ID Token）
 *
 * 注意：
 * - Apple Sign In 要求必须使用 HTTPS（localhost 除外）
 * - 返回 URL 必须与配置的完全一致
 * - 当请求 name 或 email scope 时，response_mode 必须是 form_post
 * - 使用 JS SDK 的 popup 模式可以避免页面重定向
 */
